export default __webpack_public_path__ + "static/media/NationalGeographic.92a374d1.svg";